import { ContactType, IContact } from 'models';
import { GetAllFactory, CreateFactory, UpdateFactory, DeleteFactory } from './base.service';
import CrudService from './crud.service';
import { BaseGetAllParams } from './defaults';

const BASE_URL = 'contacts';
const SERVICE_NAME = 'Contact';

interface GetAllParams extends BaseGetAllParams {
  type?: ContactType;
  text?: string;
}

// Delete this soon
export default new CrudService<IContact>(SERVICE_NAME, BASE_URL);

export const GetAll = GetAllFactory<IContact, GetAllParams>(BASE_URL);
export const Create = CreateFactory<IContact>(BASE_URL, SERVICE_NAME);
export const Update = UpdateFactory<IContact>(BASE_URL, SERVICE_NAME);
export const Delete = DeleteFactory(BASE_URL, SERVICE_NAME);
